import { FC, useMemo } from "react";
import styles from "./index.module.scss";

interface CardImgProps {
  src: string;
  width?: string | number;
  height?: string | number;
}

const CardImg: FC<CardImgProps> = ({ src, width }) => {
  const style = useMemo(() => {
    return width
      ? {
          width,
        }
      : {};
  }, [width]);

  const imgLoad = (e: any) => {
    const target = e.target as HTMLImageElement;
    const { naturalWidth, naturalHeight } = target;
    if (naturalWidth / naturalHeight < 2) {
      target.style.width = "100%";
    } else {
      target.style.height = "100%";
    }
  };

  return (
    <div className={styles["card-img"]} style={style}>
      <img src={src} alt="" onLoad={(e) => imgLoad(e)} />
    </div>
  );
};

export default CardImg;
